
import React, { useContext} from 'react';
import ProfileTopNavigation from './ProfileTopNavigation';
import { ProfileSliderContext } from '../../appContext';
import PersonalSettingsSection from '../../PageComponent/ProfilePage/Personalsettings';

function ProfileSubSettings() {
    const {handelViewRequestBlock} = useContext(
        ProfileSliderContext
      );
  return (
   
    <>
     <ProfileTopNavigation pageTitle={'Settings'} />
     <PersonalSettingsSection />
    </>
  );
}

export default ProfileSubSettings;
